import { Color } from './color';
import { Position } from './position';

export abstract class DrawAction {

    static defaults = {
        borderColor: '#777',
        cornerColor: '#777',
        cornerSize: 9,
        transparentCorners: false
    };

    abstract drawActionElement: DrawActionElement;

    protected isTouchDevice(): boolean {
        return $('html')
            .hasClass('touchevents');
    }
}

export enum DrawActionElement {
    LINE, CIRCLE, RECT, TRIANGLE, FREEHAND, TEXT, STAMP
}

export class DrawOptions {
    color?: Color;
    borderWidth?: number;
    stampingPosition?: Position;
    text: string;
}
